module.exports = __webpack_public_path__ + "img/viewed-user-active.d34a3286.svg";